/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_user = {
    readonly canShowSellerName: boolean | null;
    readonly canShowInternalSellerName: boolean | null;
    readonly canShowStorefrontOnlyBadge: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_user" | "SbRespSearchResultContainer_user" | "SbSharedRelatedItems_user" | "SbRespRefineTopNav_user" | "SbSharedRecentlySoldItems_user" | "SbRespAppliedFilters_user">;
    readonly " $refType": "SbRespMainContent_user";
};
export type SbRespMainContent_user$data = SbRespMainContent_user;
export type SbRespMainContent_user$key = {
    readonly " $data"?: SbRespMainContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    },
    {
      "alias": "canShowInternalSellerName",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "VIEW_SELLER_NAME"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
    },
    {
      "alias": "canShowStorefrontOnlyBadge",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "VIEW_STOREFRONT_ONLY_BADGE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecentlySoldItems_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '8694069ae491c8b9b0142f5c794fe526';
export default node;
